module.exports = __webpack_public_path__ + "img/2.a71d6292.png";